import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import SectionTitle from '../../components/SectionTitle';
import Button from '../../components/Button';

import shapeImg from '../../assets/img/contact/shape-1-1.png';

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', formRef.current, {
        publicKey: 'YOUR_PUBLIC_KEY',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
  };

  return (
    <div
      id="it-contact"
      className="it-contact-area p-relative z-index grey-bg-2 pt-140 pb-140"
    >
      <div className="it-contact-shape-1">
        <img src={shapeImg} alt="" />
      </div>
      <div className="it-contact-p p-relative">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6">
              <div className="it-contact-left">
                <SectionTitle
                  itemClass="it-contact-title-box mb-20 section-title-fixed-width"
                  subTitleClass="it-section-subtitle"
                  subTitle="Ask Anything"
                  titleClass="it-section-title text-white"
                  title="Prevention is better than cure"
                />
                <div className="it-contact-text">
                  <p className="mb-0 text-white">
                    Many desktop publishing packages and web page editors now
                    use Lorem Ipsum as their default model text, and a search
                    for 'lorem ipsum' will uncover.Many deskto
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div className="it-contact-from-wrap z-index">
                <form ref={formRef} onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Name" />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="email" placeholder="E-mail" />
                      </div>
                    </div>
                    <div className="col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Subject" />
                      </div>
                    </div>
                    <div className="col-12 mb-30">
                      <div className="it-contact-input-box">
                        <textarea placeholder="Comment"></textarea>
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="it-btn-theme">
                    <Button btnText="Submit now" />
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-8 col-lg-8">
              <div className="it-contact-tel-wrap">
                <div className="it-contact-tel-box d-flex align-items-center mb-40">
                  <div className="it-contact-tel-icon">
                    <span>
                      <i className="flaticon-email"></i>
                    </span>
                  </div>
                  <div className="it-contact-tel-text">
                    <a href="mailto:contact@website">
                      Main Email : contact@website
                    </a>
                    <a href="mailto:Info@mail.com">
                      ComInquiries : Info@mail.com
                    </a>
                  </div>
                </div>
                <div className="it-contact-tel-box d-flex align-items-center">
                  <div className="it-contact-tel-icon">
                    <span>
                      <i className="flaticon-email"></i>
                    </span>
                  </div>
                  <div className="it-contact-tel-text">
                    <a href="tel:0025894585">Telephone : 00258 94585</a>
                    <a href="tel:000185538456"> Mobile : 000 1855 38456</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="it-contact-bg"></div>
      </div>
    </div>
  );
};

export default Contact;
